import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useI18n, useUpsell } from "../../../../../contexts";
const FormContentBlockerFieldVisualHeroButtonText = ()=>{
    const { __ } = useI18n();
    const { isPro } = useUpsell();
    return isPro && /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.isVisual !== nextValues.isVisual || prevValues.visualType !== nextValues.visualType,
        children: (param)=>{
            let { getFieldValue } = param;
            const isVisual = getFieldValue("isVisual");
            const visualType = getFieldValue("visualType");
            return !!isVisual && visualType !== "default" && /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.visualContentType !== nextValues.visualContentType,
                children: (param)=>{
                    let { getFieldValue } = param;
                    const visualContentType = getFieldValue("visualContentType");
                    const visualType = getFieldValue("visualType");
                    return /*#__PURE__*/ _jsxs(Form.Item, {
                        label: __("Button text"),
                        style: {
                            display: [
                                "audio-player",
                                "video-player"
                            ].indexOf(visualContentType) > -1 || visualType !== "hero" ? "none" : undefined
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                name: "visualHeroButtonText",
                                noStyle: true,
                                children: /*#__PURE__*/ _jsx(Input, {})
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "description",
                                children: __("If you specify a button text, a button with this text will be centered in the image and only when you click on this button the content blocker will be opened. Otherwise, clicking on the image itself will open the Content Blocker.")
                            })
                        ]
                    });
                }
            });
        }
    });
};
export { FormContentBlockerFieldVisualHeroButtonText };
